<template>
  <div>{{formatPercent(rate)}}</div>
</template>

<script>
import { isNumeric } from 'vant/lib/utils';

export default {
  name: "DfPercentCell",
  props: {
    rate: {
      //type: [Number, String],
      default: 0, // 起始值
    },
  },
  data() {
    return {
    }
  },
  methods: {
    formatPercent(value) {
        if (isNumeric(value)) {
            return (value * 100).toFixed(2) + '%';
        } else {
            return '-';
        }
        
    }
  }
}
</script>